
import Company from './company'
import Persona from './persona'

export default {
  components: {Company, Persona},
  props: {
    cards: {type: Array, required: true},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false}
  },
}
